import React, { useState } from 'react'
import { Modal, Table, Button } from 'semantic-ui-react'
import { numFormat } from '@rededompedro/utils'
import { DateTime } from 'luxon'

export default React.memo(function ModalDetalhes({ item, setShowModalItem, setItemLista }) {

    const [open, setOpen] = useState(true)

    return (
        <Modal size={'small'} open={open}>
            <Modal.Header>Detalhes sobre a transação</Modal.Header>
            <Modal.Content scrolling>
                <Table size='small' definition compact='very'>
                    <Table.Body>
                        <Table.Row>
                            <Table.Cell>Empresa</Table.Cell>
                            <Table.Cell>{item.restaurante}</Table.Cell>
                        </Table.Row>
                        <Table.Row>
                            <Table.Cell>Estabelecimento</Table.Cell>
                            <Table.Cell>{item.estabelecimento}</Table.Cell>
                        </Table.Row>
                        <Table.Row>
                            <Table.Cell>Data Venda</Table.Cell>
                            <Table.Cell>{item.data_venda}</Table.Cell>
                        </Table.Row>
                        <Table.Row>
                            <Table.Cell>Hora Venda</Table.Cell>
                            <Table.Cell>{item.hora_venda}</Table.Cell>
                        </Table.Row>
                        <Table.Row>
                            <Table.Cell>Vinculado ao Caixa</Table.Cell>
                            <Table.Cell>{item.data_caixa} - {item.turno}</Table.Cell>
                        </Table.Row>
                        <Table.Row>
                            <Table.Cell>Resumo de Vendas</Table.Cell>
                            <Table.Cell>{item.resumo_vendas}</Table.Cell>
                        </Table.Row>
                        <Table.Row>
                            <Table.Cell>Tipo de Cartão</Table.Cell>
                            <Table.Cell>{item.descricao}</Table.Cell>
                        </Table.Row>
                        <Table.Row>
                            <Table.Cell>4 Últ. Dig. Cartão</Table.Cell>
                            <Table.Cell>{item.n_cartao}</Table.Cell>
                        </Table.Row>
                        <Table.Row>
                            <Table.Cell>Nº Comprovante</Table.Cell>
                            <Table.Cell>{item.n_comprovante}</Table.Cell>
                        </Table.Row>
                        <Table.Row>
                            <Table.Cell>Valor Bruto</Table.Cell>
                            <Table.Cell>{numFormat(item.valor_bruto)}</Table.Cell>
                        </Table.Row>
                        <Table.Row>
                            <Table.Cell>Valor Desconto</Table.Cell>
                            <Table.Cell>{numFormat(item.valor_desconto)}</Table.Cell>
                        </Table.Row>
                        <Table.Row>
                            <Table.Cell>Valor Líquido</Table.Cell>
                            <Table.Cell>{numFormat(item.valor_liquido)}</Table.Cell>
                        </Table.Row>
                        <Table.Row>
                            <Table.Cell>Previsão de Pagamento</Table.Cell>
                            <Table.Cell>{DateTime.fromFormat(item.id_prev_pagto, 'yyMMdd').toFormat('dd/MM/yyyy')}</Table.Cell>
                        </Table.Row>
                        <Table.Row>
                            <Table.Cell>Status</Table.Cell>
                            <Table.Cell>{item.status === '01' ? 'Em Aberto' : 'Finalizado'}</Table.Cell>
                        </Table.Row>
                    </Table.Body>
                </Table>
            </Modal.Content>
            <Modal.Actions>
                <Button negative onClick={() => { setShowModalItem(false); setOpen(false); setItemLista(null) }}>Fechar</Button>
                <Button
                    positive
                    icon='checkmark'
                    labelPosition='right'
                    content='Alterar Vínculo'
                />
            </Modal.Actions>
        </Modal>
    )
})